import { useExportOptions } from '@aibees/elephant/components/export-dialog/hooks/use-export-options';
import { EnrichmentTypeEnum } from '@aibees/elephant/types';
import { TemplateColumns } from '@aibees/shared/features';
import { useMemo } from 'react';

export function useEnrichmentTemplateDefaultItem(
  enrichmentType?: EnrichmentTypeEnum
) {
  const { peopleOptions, companyOptions, emailOptions } = useExportOptions();

  return useMemo(() => {
    const templateCompanyColumns: TemplateColumns = {
      categoryWithNoChildren: true,
      items: companyOptions
        ? [{ ...companyOptions, name: 'companyBasic' }]
        : [],
    };

    const templatePeopleColumns: TemplateColumns = {
      information: {
        key: 'PROFILE_INSIGHT',
        description:
          'Fields with this icon come from Profile Insight. If enabled in your export settings, they will be filled; otherwise, they will appear empty in your CSV. Ensure your export settings match your template to avoid blank columns.',
        title: 'Requires Profile Insight Enabled',
        icon: 'badge-outline',
      },
      items: peopleOptions,
    };

    const templateEmailColumns: TemplateColumns = {
      categoryWithNoChildren: true,
      items: emailOptions ? [{ ...emailOptions, name: 'Email' }] : [],
    };

    const isEmail =
      enrichmentType === EnrichmentTypeEnum.EMAIL ||
      enrichmentType === EnrichmentTypeEnum.EMAIL_FINDER ||
      enrichmentType === EnrichmentTypeEnum.EMAIL_VERIFIER;
    const isCompany = enrichmentType === EnrichmentTypeEnum.COMPANY;
    const isPerson = enrichmentType === EnrichmentTypeEnum.PERSON;

    return isEmail
      ? templateEmailColumns
      : isCompany
      ? templateCompanyColumns
      : isPerson
      ? templatePeopleColumns
      : templatePeopleColumns;
  }, [enrichmentType, peopleOptions, companyOptions]);
}
